import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";

const dashboard = {
  ...getI18nJsonProp(base, "dashboard"),
};

export default dashboard;
